import {DIRECTORY_FETCH, DIRECTORY_ADD_TAGS, DOCUMENT_REMOVE_TAG, DOCUMENT_SEARCH, DOCUMENT_ADD_TAGS, DOCUMENT_SHOW, DOCUMENTS_CLEAR, TAGS_FETCH, DOCUMENT_ROTATE} from "../actions.type"
import {DIRECTORY_SET, DOCUMENT_SET_CURRENT, DOCUMENT_UPDATE, DOCUMENTS_SET, TAGS_SET} from "../mutations.type"
import {DocumentService} from "../../services/document.service";
import {DirectoryService} from "../../services/directory.service";

const state = {
    currentDocumentSlug: null,
    currentDirectory: {
        fullName: ''
    },
    documents: [],
    tags: []
};

const getters = {
    currentDirectory(state) {
        return state.currentDirectory;
    },

    currentDirectoryName(state) {
        return state.currentDirectory.fullName;
    },

    currentDocument(state) {
        for (let index in state.documents) {
            if (state.documents[index].slug === state.currentDocumentSlug) {
                return state.documents[index];
            }
        }

        return null;
    },

    documents(state) {
        return state.documents;
    },

    medias(state) {
        let images = [];
        for (let index in state.documents) {
            if (DocumentService.isMedia(state.documents[index])) {
                images.push(state.documents[index]);
            }
        }

        return images;
    },

    mediasByDirectories(state) {
        let imagesByDirectories = {};
        for (let index in state.documents) {
            let document = state.documents[index];

            if (DocumentService.isMedia(document)) {
                if (!(document.directorySlug in imagesByDirectories)) {
                    imagesByDirectories[document.directorySlug] = {
                        'directoryFullName': document.directoryFullName,
                        'documents': []
                    };
                }

                imagesByDirectories[document.directorySlug].documents.push(document);
            }
        }

        return imagesByDirectories;
    },

    parentDirectory(state) {
        return state.currentDirectory.parent;
    },

    subDirectories(state) {
        return state.currentDirectory.children;
    },

    tags(state) {
        return state.tags;
    }
};

const actions = {
    [DIRECTORY_ADD_TAGS](state, payload) {
        return DirectoryService.addTags(payload);
    },

    async [DIRECTORY_FETCH](state, directorySlug = null) {
        let response = await DirectoryService.fetch(directorySlug);
        state.commit(DIRECTORY_SET, response.data);
        state.commit(DOCUMENTS_SET, response.data.documents);

        return response;
    },

    [DOCUMENT_ADD_TAGS](state, payload) {
        return DocumentService.addTags(payload)
            .then(response => {
                state.commit(DOCUMENTS_SET, response.data);
            });
    },

    [DOCUMENT_REMOVE_TAG](state, payload) {
        return DocumentService.removeTag(payload)
            .then(response => {
                state.commit(DOCUMENT_UPDATE, response.data);
            });
    },

    [DOCUMENT_ROTATE](state, payload) {
        return DocumentService.rotate(payload)
            .then(response => {
                let document = DocumentService.invalidateCache(response.data);
                state.commit(DOCUMENT_UPDATE, document);
            });
    },

    [DOCUMENT_SEARCH](state, tagsSlug) {
        state.commit(DOCUMENTS_SET, []);
        return DocumentService.searchByTags(tagsSlug)
            .then(response => {
                state.commit(DOCUMENTS_SET, response.data);
            });
    },

    [DOCUMENT_SHOW](state, documentSlug) {
        state.commit(DOCUMENT_SET_CURRENT, documentSlug);
    },

    [DOCUMENTS_CLEAR](state) {
        state.commit(DOCUMENTS_SET, null);
    },

    [TAGS_FETCH](state) {
        return DocumentService.fetchTags()
            .then(response => {
                state.commit(TAGS_SET, response.data);
            });
    }
};

const mutations = {
    [DIRECTORY_SET](state, directory) {
        state.currentDirectory = directory;
    },

    [DOCUMENT_SET_CURRENT](state, documentSlug) {
        state.currentDocumentSlug = null;
        for (let index in state.documents) {
            if (state.documents[index].slug === documentSlug) {
                state.currentDocumentSlug = documentSlug;
                break;
            }
        }
    },

    [DOCUMENT_UPDATE](state, document) {
        let documents = [];
        for (let index in state.documents) {
            if (state.documents[index].slug === document.slug) {
                documents[index] = document;
            } else {
                documents[index] = state.documents[index];
            }
        }

        // Obligatoire pour "rafraichir" le state
        state.documents = documents;
    },

    [DOCUMENTS_SET](state, documents) {
        if (Array.isArray(documents)) {
            state.documents = documents;
        } else if (documents) {
            state.documents = [documents];
        } else {
            state.documents = null;
        }
    },

    [TAGS_SET](state, tags) {
        state.tags = tags;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}